import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { WorkOrder, WorkOrderSearchCommand } from '../../models/order/work-order';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';

@Injectable({ providedIn: 'root' })
export class WorkOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/work-order';

  public createWorkOrder(data: WorkOrder): Observable<ApiResponse<WorkOrder>> {
    return this.httpClient.post<ApiResponse<WorkOrder>>(this.baseUrl, data);
  }

  public updateWorkOrder(id: string, data: WorkOrder): Observable<ApiResponse<WorkOrder>> {
    return this.httpClient.put<ApiResponse<WorkOrder>>(this.baseUrl + '/' + id, data);
  }

  public getWorkOrders(): Observable<ApiResponse<WorkOrder[]>> {
    return this.httpClient.get<ApiResponse<WorkOrder[]>>(this.baseUrl + '/all');
  }

  public getWorkOrderById(id: string, materialize = true): Observable<ApiResponse<WorkOrder>> {
    return this.httpClient.get<ApiResponse<WorkOrder>>(this.baseUrl + '/' + id + '?materialize=' + materialize);
  }

  public getWorkOrderByIdNotArray(id: string, materialize = true): Observable<ApiResponse<WorkOrder>> {
    return this.httpClient.get<ApiResponse<WorkOrder>>(this.baseUrl + '/' + id + '?materialize=' + materialize);
  }

  public searchWorkOrder(
    command: WorkOrderSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder?: number,
  ): Observable<ApiResponse<PaginatedApiResponse<WorkOrder>>> {
    let params = new HttpParams().set('pageNumber', pageNumber.toString()).set('pageSize', pageSize.toString());
    if (sortField) params = params.set('sortField', sortField);
    if (sortOrder !== undefined) params = params.set('sortOrder', sortOrder.toString());
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<WorkOrder>>>(this.baseUrl + '/search', command, { params });
  }

  public updateStatus(id: string, nextStatus: string): Observable<ApiResponse<WorkOrder>> {
    return this.httpClient.patch<ApiResponse<WorkOrder>>(this.baseUrl + '/' + id + '/status/' + nextStatus, null);
  }

  public updatePackingType(workOrderId: string, command: { fabricCode: string; packingType: number }): Observable<ApiResponse<void>> {
    return this.httpClient.patch<ApiResponse<void>>(`${this.baseUrl}/${workOrderId}/packing-type`, command);
  }
}
